import reducer from "./reducer";
export { default as HistoricAccumulators } from "./components/index";
export { default as historicAccumulatorsReducerName } from "./constants";
export default reducer;
